import { ChatCard } from "./ChatCard";

export default ChatCard;
